var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 26.875C43.975 26.875 43.125 26.025 43.125 25V20C43.125 12.125 40.9 6.875 30 6.875C19.1 6.875 16.875 12.125 16.875 20V25C16.875 26.025 16.025 26.875 15 26.875C13.975 26.875 13.125 26.025 13.125 25V20C13.125 12.75 14.875 3.125 30 3.125C45.125 3.125 46.875 12.75 46.875 20V25C46.875 26.025 46.025 26.875 45 26.875Z",
    fill: "#026C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 48.125C25.525 48.125 21.875 44.475 21.875 40C21.875 35.525 25.525 31.875 30 31.875C34.475 31.875 38.125 35.525 38.125 40C38.125 44.475 34.475 48.125 30 48.125ZM30 35.625C27.6 35.625 25.625 37.6 25.625 40C25.625 42.4 27.6 44.375 30 44.375C32.4 44.375 34.375 42.4 34.375 40C34.375 37.6 32.4 35.625 30 35.625Z",
    fill: "#026C96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 56.875H17.5C6.475 56.875 3.125 53.525 3.125 42.5V37.5C3.125 26.475 6.475 23.125 17.5 23.125H42.5C53.525 23.125 56.875 26.475 56.875 37.5V42.5C56.875 53.525 53.525 56.875 42.5 56.875ZM17.5 26.875C8.55 26.875 6.875 28.575 6.875 37.5V42.5C6.875 51.425 8.55 53.125 17.5 53.125H42.5C51.45 53.125 53.125 51.425 53.125 42.5V37.5C53.125 28.575 51.45 26.875 42.5 26.875H17.5Z",
    fill: "#026C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bb1144a9267163c6a3d53f9e29ca6732.svg";
export { ForwardRef as ReactComponent };